import * as React from 'react';
// { activeStep: number, setCurrentStepActive: function, stepCount: number }
const StepperContext = React.createContext({});

export default StepperContext;